<template>
  <div class="container">
    <h2>学员暂未绑定网校，可手动进行绑定</h2>
    <!-- 表单 -->
    <a-form :form="form">
      <a-form-item>
        <a-input
          placeholder="手机号/网校客户编号"
          v-decorator="[
            'userTxt',
            { rules: [{ required: true, message: '请输入绑定的用户' }] },
          ]" />
      </a-form-item>
    </a-form>
    <a-button type="primary" @click="bindCrmUser">确定绑定</a-button>
  </div>
</template>

<script>
import { bindWechatToCrmCustomer } from "@/api/auth";
import { getCurExternalContact } from "@/utils/wxCodeAuth";
import store from "@/store";
export default {
  name: "bindCrmUser",
  components: {},
  data() {
    return {
      form: this.$form.createForm(this, { userTxt: "" }),
    };
  },
  methods: {
    bindCrmUser() {
      // 校验表单
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.info("校验success", values);
          let userInfo = localStorage.getItem("userInfo");
          if (!userInfo) console.log("没有userInfo");
          else userInfo = JSON.parse(userInfo);

          const externalUserId = await getCurExternalContact();

          let data = {
            appId: store.getters.agentId,
            bindCustomer: values.userTxt,
            corpId: store.getters.corpId,
            externalUserId,
            wechatUserId: userInfo.userId,
            tenantId: store.getters.tenantId,
          };
          console.log("没值吗？", store.getters.tenantId);

          const { result } = await bindWechatToCrmCustomer(data);
          this.$alert("绑定成功", result, "path:", this.$route);

          // 如果有重定向地址则完成后跳转
          if (this.$route.query.redirect)
            this.$router.push(this.$route.query.redirect);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  input {
    margin-top: 30px;
    width: 300px;
  }
  button {
    margin-top: 20px;
  }
}
</style>
